import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { Multiple } from '../../../components/multiple-text-blurb-for-grid';
import { messages } from './messages';

const SourceCollapsed = ({ fulfillmentPlanId }) => {
  const salesOrders = useSelector((state) =>
    Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, {
      fulfillmentPlanIds: [fulfillmentPlanId],
    }),
  );

  if (salesOrders.length === 1) {
    const [{ salesOrderId }] = salesOrders;

    return <SourceExpanded salesOrderId={salesOrderId} />;
  }

  const hasSource = salesOrders.some((so) => so.originalSource);

  return hasSource ? <Multiple /> : null;
};

SourceCollapsed.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

const SourceExpanded = ({ salesOrderId }) => {
  const originalSource = useSelector((state) =>
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'originalSource',
    }),
  );

  return originalSource ?? '';
};

SourceExpanded.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
};

export const Source = {
  getMessageDescriptor: () => messages.source,
  id: 'source',

  render: (data, { allData, isExpanded = false, isFirstOfType = true } = {}) => {
    if (!isExpanded && allData?.length > 1) {
      return <SourceCollapsed fulfillmentPlanId={data.id} />;
    }
    if (!data || !isFirstOfType) {
      return '';
    }
    return <SourceExpanded salesOrderId={data.salesOrderId} />;
  },
};
